module.exports = __webpack_public_path__ + "img/logo-civille.4f2cd39c.svg";